import helper from '../../helper';

export default {
	state: {
		formData: {
			loading: false,
		},
	},
	mutations: {
		requestUpdatePartCharge(state) {
			state.formData.loading = true;
		},
		successUpdatePartCharge(state) {
			state.formData.loading = false;
		},
	},
	actions: {
		async updatePartCharge({ commit }, params) {
			return helper(this, async () => {
				const data = { ...params };
				for (let i = 0; i < data.subs.length; i++) {
					data.subs[i].is_bfjf = data.subs[i].is_bfjf ? 'YES' : 'NO';
				}
				commit('requestUpdatePartCharge');
				await a.api('setBfjf', data);
				commit('successUpdatePartCharge');
			});
		},
	},
};
